<div class="flex items-center text-ui-dark text-sm gap-3">
  <span class="font-semibold">Timeout</span>
  <div class="h-1.5 flex-1 overflow-hidden bg-ui-gray-950">
    <div
      class="bg-ui-gray-100 h-full transition-all duration-1000"
      [style.width.%]="progress()"
    ></div>
  </div>
  <span>{{ formattedTime() }}</span>
</div>
